<template>
  <el-dialog
    :title="$t('text.add_floor')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    v-if="dialogVisible"
    @close="closeDialog()"
    width="630px"
    class="batch-operation"
  >
    <div class="step-wrapper">
      <el-steps
        :active="activeCard"
        finish-status="success"
        simple
        class="add-building-step"
      >
        <el-step
          :title="$t('text.floor_information')"
          icon="el-icon-school"
          :class="activeCard === 0 ? 'active-step' : ''"
        ></el-step>
        <el-step
          :title="$t('text.room_information')"
          icon="el-icon-help"
          :class="activeCard === 1 ? 'active-step' : ''"
        ></el-step>
      </el-steps>
    </div>
    <el-form
      v-show="activeCard === 0"
      label-width="120px"
      :model="form"
      size="mini"
      ref="form"
      :rules="rules"
      label-position="top"
      v-loading="loading"
    >
      <el-form-item :label="$t('text.floor_name')" prop="floorName">
        <el-input
          v-model="form.floorName"
          :placeholder="$t('text.floor_name')"
          class="wp-100"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.number_of_rooms')" prop="numberOfRooms">
        <el-input-number
          v-model="form.numberOfRooms"
          :placeholder="$t('text.number_of_rooms')"
          :min="1"
          step-strictly
          class="wp-100"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <FloorTree
      v-show="activeCard === 1"
      ref="floorTree"
      :data="data"
      :selectedBuilding="selectedBuilding"
      @loadingChange="loadingChange"
      @saveSuccessfully="saveSuccessfully"
    />
    <div slot="footer" class="dialog-footer">
      <el-button
        type="text"
        class="back-btn"
        v-if="activeCard !== 0"
        @click="back()"
        ><i class="el-icon-arrow-left mr-5"></i
        >{{ $t('text.back').toUpperCase() }}</el-button
      >
      <el-button
        class="common-btn min-w-80"
        @click="submit()"
        :loading="loading"
        v-if="activeCard === 1"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="common-btn min-w-80" @click="next()" v-else>{{
        $t('text.continue').toUpperCase()
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import FloorTree from '@/components/manage/building/FloorTree.vue'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      activeCard: 0,
      data: [
        {
          id: 0,
          label: '',
          type: 'floor',
          children: [
            {
              id: Math.random(),
              label: '',
              type: 'room'
            }
          ]
        }
      ],
      form: {
        floorName: '',
        numberOfRooms: 1
      },
      rules: {
        floorName: [
          {
            required: true,
            message: this.$t('text.please_enter_floor_name'),
            trigger: 'blur'
          }
        ],
        numberOfRooms: [
          {
            required: true,
            message: this.$t('text.please_enter_number_of_rooms'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    FloorTree
  },
  props: {
    selectedBuilding: {
      type: Object,
      require: true
    }
  },
  methods: {
    loadingChange(val) {
      this.loading = val
    },
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        floorName: '',
        numberOfRooms: 1
      }
      this.activeCard = 0
      this.dialogVisible = false
    },
    next() {
      let structure = [
        {
          id: 0,
          label: this.form.floorName,
          type: 'floor',
          children: this.generateFloorStructure()
        }
      ]
      this.data = JSON.parse(JSON.stringify(structure))
      this.activeCard++
    },
    generateFloorStructure() {
      let rooms = []
      for (let i = 0; i < this.form.numberOfRooms; i++) {
        rooms.push({
          id: Math.random(),
          label: 'Room ' + (i + 1),
          type: 'room'
        })
      }
      return rooms
    },
    back() {
      this.activeCard--
    },
    submit() {
      this.$refs.floorTree.submit()
    },
    saveSuccessfully() {
      this.$emit('updateBuilding')
      this.closeDialog()
    }
  }
}
</script>
